import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { ISendInteractionAboutGeppParams } from '../../../../shared/models/Analytics';
import { ContenidoClientes } from '../../../../shared/models/ContenidoClientes';

@Component({
  selector: 'app-cards-consumidor',
  templateUrl: './cards-consumidor.component.html',
  styleUrls: ['./cards-consumidor.component.scss'],
})
export class CardsConsumidorComponent implements OnInit {

  @Input() banner: ContenidoClientes
  @Input() index?: number

  public thumbnailUrl: any

  constructor(
    private analytService: SharedAnalyticsService
  ) { }

  ngOnInit() {
    // const toDataURL = url => fetch(url)
    //   .then(response => response.blob())
    //   .then(blob => new Promise((resolve, reject) => {
    //     const reader = new FileReader()
    //     reader.onloadend = () => resolve(reader.result)
    //     reader.onerror = reject
    //     reader.readAsDataURL(blob)
    //   }))


    // toDataURL(this.banner.Tipo === 'YouTube' ? './assets/img_placeholder_yt.png' : './assets/img_placeholder.png')
    //   .then(dataUrl => {
    //     this.thumbnailUrl = dataUrl
    //   })
    this.thumbnailUrl = this.banner.Tipo === 'YouTube' ? 'yt' : 'others'
  }

  private async launchApp(iosApp: string, androidApp: string, appUrl: string, webUrl: string) {
    const device = await Device.getInfo();
    if (device.platform === 'android') Browser.open({ url: appUrl });
    if (device.platform === 'ios') Browser.open({ url: webUrl });
    Browser.open({ url: webUrl });
  }

  public openUrl(app: string, name: string, fbUrl?: string) {
    const params: ISendInteractionAboutGeppParams = {
      card_position: this.isBannerCard() ? "banner principal" : (this.index ?? 0) + 1,
      card_id: this.banner.Id_Contenido_Cliente,
      element: this.banner.Titulo

    }
    this.analytService.sendInteractionAboutGepp(params);

    switch (app) {
      case 'facebook':
        this.launchApp('fb://', 'com.facebook.katana', 'fb://facewebmodal/f?href=' + fbUrl, fbUrl)
        break
      case 'instagram':
        this.launchApp('instagram://', 'com.instagram.android', 'instagram://user?username=' + name, fbUrl)
        break
      case 'twitter':
        this.launchApp('twitter://', 'com.twitter.android', 'twitter://user?screen_name=' + name, fbUrl)
        break
      default:
        this.launchApp('', '', '', fbUrl)
        break
    }
  }

  private isBannerCard() {
    return this.banner.Tipo === 'YouTube'
  }

}
